export const valoresExibidosOffCanvasContratos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',
  separadorItens: '',

  //Específicos
  statusContrato: 'Status do Contrato',
  componenteAf: 'Componente AF',
  itemAdquirido: 'Item Adquirido',
  fornecedor: 'Fornecedor',
  leiLicitacao: 'Lei de Licitação',
  numeroSeiContrato: 'Processo Aquisitivo',
  numeroContrato: 'Nº Contrato',
  dataPublicacao: 'Início da Vigência',
  dataVigencia: 'Final da Vigência',
  prazoVigencia: 'Prazo',
};

export const headersContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'idContrato' },
  { text: 'Status', width: 8, key: 'statusContrato' },
  { text: 'Comp. AF', width: 10, key: 'componenteAfContrato' },
  { text: 'Nº Contrato', width: 8, key: 'numeroContrato' },
  { text: 'Fornecedor', width: 15, key: 'fornecedorContrato' },
  { text: 'Denominação/Kit', width: 15, key: 'denominacaoGenericaContrato' },
];

export const headersObjetosContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 50, key: 'itemProduto' },
  { text: 'Qtd Registrada', width: 10, key: 'itemQtdRegistrada' },
  { text: 'V. Homologado R$', width: 10, key: 'itemValorHomologado' },
  { text: 'V. Reequilibrio R$', width: 10, key: 'itemValorReequilibrio' },
  { text: 'Valor Total R$', width: 10, key: 'itemValorTotal' },
];

export const headersParcelasContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 50, key: 'itemProduto' },
  { text: 'Qtd Registrada', width: 10, key: 'itemQtdRegistrada' },
  { text: 'V. Homologado R$', width: 10, key: 'itemValorHomologado' },
  { text: 'V. Reequilibrio R$', width: 10, key: 'itemValorReequilibrio' },
  { text: 'Valor Total R$', width: 10, key: 'itemValorTotal' },
];

export const headersPautasEntregasContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 50, key: 'itemProduto' },
  { text: 'Qtd Registrada', width: 10, key: 'itemQtdRegistrada' },
  { text: 'V. Homologado R$', width: 10, key: 'itemValorHomologado' },
  { text: 'V. Reequilibrio R$', width: 10, key: 'itemValorReequilibrio' },
  { text: 'Valor Total R$', width: 10, key: 'itemValorTotal' },
];

export const headersEntregasContratos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Cota', width: 10, key: 'itemTipoCota' },
  { text: 'Produto', width: 50, key: 'itemProduto' },
  { text: 'Qtd Registrada', width: 10, key: 'itemQtdRegistrada' },
  { text: 'V. Homologado R$', width: 10, key: 'itemValorHomologado' },
  { text: 'V. Reequilibrio R$', width: 10, key: 'itemValorReequilibrio' },
  { text: 'Valor Total R$', width: 10, key: 'itemValorTotal' },
];

export const fieldObjectContratos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];

export const headersContratosResponsavel = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 15, key: 'status' },
  { text: 'Data Início', width: 15, key: 'dataInicio' },
  { text: 'Data Fim', width: 15, key: 'dataFim' },
  { text: 'Responsável', width: 50, key: 'responsavel' },
];

export const valoresExibidosOffCanvasContratosResponsavel: Record<
  string,
  string
> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersContratosTermoAditivo = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 15, key: 'status' },
  { text: 'Data DOU', width: 15, key: 'dataDou' },
  { text: 'Tipo de TA', width: 15, key: 'tipoTA' },
  { text: 'Nº DOC SEI', width: 15, key: 'docSei' },
  { text: 'Objeto', width: 50, key: 'objeto' },
];

export const valoresExibidosOffCanvasContratosTermoAditivo: Record<
  string,
  string
> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersContratosPautas = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Inst.', width: 8, key: 'instrumento' },
  { text: 'Nº Inst.', width: 7, key: 'numeroInstrumento' },
  { text: 'Nº Parcela', width: 7, key: 'parcela' },
  { text: 'Nº Pauta', width: 7, key: 'numeroPauta' },
  { text: 'Produto', width: 25, key: 'produto' },
  { text: 'Qtd Pauta', width: 8, key: 'qtdPauta' },
  { text: 'Valor R$', width: 8, key: 'valorPauta' },
  { text: 'Qtd Entregue', width: 8, key: 'qtdEntregue' },
];

export const headersContratosEntregas = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Tipo Inst.', width: 8, key: 'instrumento' },
  { text: 'Nº Inst.', width: 7, key: 'numeroInstrumento' },
  { text: 'Nº Parcela', width: 7, key: 'parcela' },
  { text: 'Nº Pauta', width: 7, key: 'numeroPauta' },
  { text: 'Item Pauta', width: 7, key: 'itemPauta' },
  { text: 'Produto', width: 25, key: 'produto' },
  { text: 'Qtd Pauta', width: 8, key: 'qtdPauta' },
  { text: 'Qtd Entregue', width: 8, key: 'qtdEntregue' },
  { text: '% Entregue', width: 8, key: 'percentualEntregue' },
];

export const headersContratosEntregaItem = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Data da Entrega', width: 10, key: 'dataEntrega' },
  { text: 'Total Entregue', width: 10, key: 'totalEntregue' },
  { text: '% do Item da Pauta', width: 10, key: 'percentualItemPauta' },
  { text: 'Nota fiscal', width: 10, key: 'notaFiscal' },
  { text: 'Valor Nota R$', width: 10, key: 'valorNota' },
  { text: 'Status Nota', width: 10, key: 'statusNota' },
];

export const tableEntregaItem = [
  {
    n: '',
    id: 1,
    dataEntrega: '04/04/2025',
    totalEntregue: '17.500',
    percentualItemPauta: '60%',
    notaFiscal: '0340457694',
    valorNota: '45.000,00',
    statusNota: 'Validado',
  },
  {
    n: '',
    id: 2,
    dataEntrega: '29/04/2025',
    totalEntregue: '10.500',
    percentualItemPauta: '40%',
    notaFiscal: 'Não Enviado',
    valorNota: '-',
    statusNota: '-',
  },
];

import { CustomTableHeader } from '../../../../components/CustomTable';
import { Header } from '../../../../components/EditableTable';
import {
  renderComponenteAF,
  renderStatusExecucao,
  renderTipoProduto,
} from '../ProcessosLicitatorios/auxiliarProcessosLicitatorios';
export const headersPautasItens: Header[] = [
  { key: 'id', label: 'ID' },
  { key: 'status', label: 'Status' },
  { key: 'uf', label: 'UF', editable: false },
  {
    key: 'data',
    label: 'Data Prevista',
    editable: true,
    type: 'date',
    width: '120px',
    align: 'right',
  },
  {
    key: 'total',
    label: 'Qtd Total',
    editable: true,
    type: 'number',
    width: '150px',
    align: 'right',
  },
  { key: 'embalagens', label: 'Embalagens', align: 'right' },
  { key: 'nEntregas', label: 'Nº Entregas', align: 'right' },
  { key: 'data1entrega', label: '1ª Entrega', align: 'right' },
  { key: 'dataUltentrega', label: 'Últ. Entrega', align: 'right' },
  { key: 'totEntregue', label: 'Total Entregue', align: 'right' },
  { key: 'percentualEntregue', label: '% Entregue', align: 'right' },
];

export const dataItensPautas = [
  {
    id: 1,
    status: 'Ativo',
    uf: 'AC',
    data: '01/03/2025',
    total: 2000,
    embalagens: 300,
    nEntregas: 2,
    data1entrega: '05/03/2025',
    dataUltentrega: '25/03/2025',
    totEntregue: 1500,
    percentualEntregue: '75%',
  },
];

export type ContratosTableRow = {
  id: string | number;
  status: string;
  componenteAf: string;
  numeroContrato: string;
  fornecedor: string;
  denominacaoKit: string;
  denominacaoKitBool: string;
  [key: string]: any;
};

// Headers da Tabela de Contratos
export const headersContratosCustomTable: CustomTableHeader<ContratosTableRow>[] =
  [
    { text: '', width: 1, key: '', renderable: false },
    {
      text: 'ID',
      width: 6,
      key: 'id',
      fieldType: 'number',
      textAlign: 'center',
    },
    {
      text: 'Status',
      width: 12,
      key: 'status',
      fieldType: 'select',
      renderCell: (value) => renderStatusExecucao(value),
    },
    {
      text: 'Componente AF',
      width: 12,
      key: 'componenteAf',
      fieldType: 'select',
      renderCell: (value) => renderComponenteAF(value),
    },
    {
      text: 'Modalidade',
      width: 12,
      key: 'modalidade',
      fieldType: 'select',
    },
    {
      text: 'Nº do Contrato',
      width: 10,
      key: 'numeroContrato',
      fieldType: 'text',
    },
    {
      text: 'Fornecedor',
      width: 30,
      key: 'fornecedor',
      fieldType: 'text',
    },
    {
      text: 'Tipo',
      width: 5,
      key: 'denominacaoKitBool',
      fieldType: 'select',
      renderCell: (value) => renderTipoProduto(value),
    },
    {
      text: 'Denominação ou Kit',
      width: 50,
      key: 'denominacaoKit',
      fieldType: 'text',
    },
  ];
